import { firmLabel, groupLabel, targetLabel } from "./moveBpaLabels.js";
import type { ParsedMoveBpaCsv } from "./parseMoveBpaCsv.js";
import styles from "../PipelineBrowser.module.css";

const DISPLAY_CAP = 50;

type MoveBpaParsedSummaryProps = {
  fileName: string;
  parsed: ParsedMoveBpaCsv;
};

export function MoveBpaParsedSummary({ fileName, parsed }: MoveBpaParsedSummaryProps) {
  const shown = parsed.invalid.slice(0, DISPLAY_CAP);
  const hidden = parsed.invalid.length - shown.length;

  return (
    <>
      <div className={styles.syncStateMessage}>
        {fileName}: <strong>{parsed.valid.length}</strong> valid rows,{" "}
        <strong>{parsed.invalid.length}</strong> invalid
      </div>
      {parsed.invalid.length > 0 && (
        <>
          <div className={styles.mappingError}>
            Invalid rows must be fixed before the move can run.
          </div>
          <ul className={styles.problemList} aria-label="Invalid rows">
            {shown.map(row => (
              <li key={row.line}>
                Line {row.line}: {row.reason}
              </li>
            ))}
          </ul>
          {hidden > 0 && <div className={styles.syncStateMessage}>…and {hidden} more.</div>}
        </>
      )}
      {parsed.valid.length > 0 && (
        <div className={styles.tableContainer}>
          <table className={styles.crossRefTable} aria-label="Rows to move">
            <thead>
              <tr>
                <th>Line</th>
                <th>Firm</th>
                <th>Publication</th>
                <th>Source practice areas</th>
                <th>Target</th>
                <th>Expected items</th>
              </tr>
            </thead>
            <tbody>
              {parsed.valid.map(row => (
                <tr key={row.line}>
                  <td>{row.line}</td>
                  <td>{firmLabel(row)}</td>
                  <td>{row.publicationId}</td>
                  <td>{groupLabel(row)}</td>
                  <td>{targetLabel(row)}</td>
                  <td>{row.expectedItems ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
